import { SLOW_LAP_EXCLUSION_PCT } from '../config/lapFiltering'

export interface OutlierLapInput {
  lapId: string
  lapTimeMs: number | null | undefined
}

export function computeAutoExcludedLapIds(
  laps: OutlierLapInput[]
): Set<string> {
  const excluded = new Set<string>()
  if (laps.length < 3) return excluded

  const lapTimes = laps
    .map((l) => ({ lapId: l.lapId, time: l.lapTimeMs }))
    .filter(
      (l): l is { lapId: string; time: number } => l.time != null && l.time > 0
    )
  if (lapTimes.length < 3) return excluded

  const sorted = [...lapTimes].sort((a, b) => a.time - b.time)
  // True median: average the two middle values for even counts. Anchoring
  // on the upper-middle element biased the deviation band toward slower
  // laps and could flip which lap gets excluded on lap-count parity.
  const mid = Math.floor(sorted.length / 2)
  const median =
    sorted.length % 2 === 0
      ? (sorted[mid - 1].time + sorted[mid].time) / 2
      : sorted[mid].time

  lapTimes.forEach(({ lapId, time }) => {
    if ((time - median) / median > SLOW_LAP_EXCLUSION_PCT / 100) {
      excluded.add(lapId)
    }
  })

  const remaining = laps.length - excluded.size
  if (excluded.size > 0 && remaining >= 2) return excluded
  return new Set<string>()
}
